import { Card } from "../ui/card.tsx"
import { FileText, PenLine } from "lucide-react"
import { Button } from "../ui/button.tsx"

export function DocumentsCard() {
  return (
    <Card className="p-6">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="font-semibold">Documents</h3>
        <Button variant="ghost" size="icon">
          <PenLine className="h-4 w-4" />
        </Button>
      </div>

      <div className="space-y-3">
        <Button variant="ghost" className="w-full justify-start gap-2">
          <FileText className="h-4 w-4" />
          Contract
        </Button>
        <Button variant="ghost" className="w-full justify-start gap-2">
          <FileText className="h-4 w-4" />
          Birth Cert
        </Button>
      </div>
    </Card>
  )
}

